export const BONUS_FORMS = ['бонус', 'бонуса', 'бонусов'] as const;

export const BONUS_FORMS_WITH_COUNT = ['%d бонуса', '%d бонусов', '%d бонусов'] as const;
